<template>
  <div>
    <div class="mb-8"></div>
    <section class="flex flex-col-reverse md:flex-row container mx-auto">
      <!-- Image -->
      <div class="flex w-full md:w-3/5 items-center mx-auto">
        <img
          alt="logo"
          class="w-full"
          :src="$S3AssetUrl('suf/profile/register-user.jpg')"
        />
      </div>

      <!-- Resend Access Code Form -->
      <div class="flex flex-col w-full md:w-2/5 mx-auto px-4">
        <h2 class="py-2 text-2xl font-bold">
            {{ $t("Forms.still_received_activation_code") }}
        </h2>
        <p class="mb-4">
          {{ $t('Forms.new_activate_code_description') }}
        </p>

        <p class="py-3">
          {{ $t('Forms.if_you_have_account') }}
          <router-link
            :to="{ name: 'login' }"
            class="cursor-pointer text-newxcaret-blue"
          >
            {{ $t('Forms.login') }}
          </router-link>
        </p>

        <ValidationObserver v-slot="{ handleSubmit }">
          <form
            @submit.prevent="handleSubmit(resendAccessCode)"
            class="flex flex-col w-full pt-2 pb-6 relative"
          >
            <ValidationProvider rules="required|email" v-slot="{ errors }">
              <label class="font-bold" :for="$t('Forms.email')">{{
                $t('Forms.email')
              }}</label>
              <input
                type="text"
                :placeholder="$t('Forms.email')"
                v-model="form.email"
                :id="$t('Forms.email')"
                :name="$t('Forms.email')"
                class="
                  w-full
                  h-10
                  p-3
                  my-2
                  border border-newxcaret-blue
                  bg-white
                  rounded-lg
                "
              />
              <p class="txt-error text-red text-xs italic">
                {{ errors[0] }}
              </p>
            </ValidationProvider>

            <div class="flex flex-col md:flex-row items-center">
              <button
                type="submit"
                class="
                  flex
                  w-full
                  items-center
                  justify-center
                  w-full
                  mt-4
                  p-2
                  bg-yellow-photo
                  rounded-full
                  text-sm
                  font-semibold
                "
              >
                {{ $t('Forms.send') }}
              </button>
            </div>
            <p class="italic mt-4">
                <span class="text-red font-bold">*</span><i>{{ $t('Forms.new_activate_code_note') }}</i>
            </p>
          </form>
        </ValidationObserver>
      </div>
    </section>
  </div>
</template>

<script>
import "../validators/index";
import resendAccessCodeData from "../logic/profile/resendAccessCode";

export default {
  props: [],
  mixins: [],
  components: {},
  data: () => ({
    loading: false,
    form: {
      email: ""
    }
  }),
  watch: {},
  methods: {
    async resendAccessCode() {
      try {
        this.$store.dispatch("setLoading", true);
        let { data } = await resendAccessCodeData.post({ Username: this.form.email });
        if(data?.SUCCESS == "false"){
          Vue.$toast.open({
            message: this.$t("Forms.try_catch_api"),
            type: "error",
          });
          return;
        }

        Vue.$toast.open({
          message: this.$t("Forms.resend_access_code"),
          type: "success",
        });

        this.$router.push({ name: "activate" });
      } catch (error) {
        Vue.$toast.open({
          message: this.$t("Forms.try_catch_api"),
          type: "error",
        });        
      } finally {
        this.$store.dispatch("setLoading", false);
      }
    }
  },
  mounted() {},
};
</script>